var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnbchain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9142 20.0001L12.9247 23.8684L16.2116 25.8025V28.0672L11.0012 25.0113V18.8689L12.9142 20.0001ZM12.9142 16.1319V18.386L11 17.2537V14.9995L12.9142 13.8672L14.8378 14.9995L12.9142 16.1319ZM17.5842 14.9995L19.4984 13.8672L21.422 14.9995L19.4984 16.1319L17.5842 14.9995Z",
    fill: "#F0B90B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2974 23.0666V20.8019L16.2116 21.9342V24.1884L14.2974 23.0666ZM17.5842 26.6136L19.4984 27.746L21.422 26.6136V28.8678L19.4984 30.0001L17.5842 28.8678V26.6136ZM24.1672 14.9995L26.0814 13.8672L28.005 14.9995V17.2537L26.0814 18.386V16.1319L24.1672 14.9995ZM26.0814 23.8684L26.092 20.0001L28.0062 18.8678V25.0101L22.7958 28.066V25.8013L26.0814 23.8684Z",
    fill: "#F0B90B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7086 23.0664L22.7944 24.1882V21.9341L24.7086 20.8018V23.0664Z",
    fill: "#F0B90B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7088 16.9335L24.7194 19.1982L21.4231 21.1323V25.01L19.5089 26.1318L17.5947 25.01V21.1323L14.2985 19.1982V16.9335L16.2209 15.8012L19.4972 17.7447L22.7934 15.8012L24.717 16.9335H24.7088ZM14.2974 13.0665L19.4984 10L24.7088 13.0665L22.7946 14.1988L19.4984 12.2553L16.2116 14.1988L14.2974 13.0665Z",
    fill: "#F0B90B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnbchain);
export default __webpack_public_path__ + "static/media/bnbchain.7963ad7093f9ad8161b3b9d92d459401.svg";
export { ForwardRef as ReactComponent };